// @flow

import * as mobx from 'mobx'
import PT from 'prop-types'
import { Observable } from 'rxjs/Observable'
import * as o from 'rxjs/operators'
import type { Params } from '@vimcar/shared-utils/linkViewModel'
import type { Users } from '@vimcar/shared-stores/mobx/users'
import logger from '@vimcar/shared-utils/logger'

import { languages } from '#utils/i18n'

export type ViewModel = {|
  languageOptions: Array<{
    code: string,
    disabled: boolean,
    label: string,
  }>,
  loading: boolean,
  handleLanguageChange: (e: SyntheticEvent<*>, code: string) => void,
  currentLanguage: string,
|}

export type Props = {||}

type Context = {
  models: { users: Users }
}

const mkViewModel = (
  { registerObservable }: Params,
  props: Props,
  ctx: Context,
): ViewModel => {
  const selfUser = ctx.models.users.self

  if (!selfUser) throw new Error('User must be logged in.')

  const vm: ViewModel = mobx.observable(({
    loading: false,

    get languageOptions() {
      return Object.entries(languages).map(
        ([code, label]) => ({
          code,
          // $FlowFixMe flow thinks this is mixed
          label,
          disabled: vm.loading,
        })
      )
    },

    get currentLanguage() {
      return selfUser.locale
    },

    handleLanguageChange: mobx.action((e, code) => {
      vm.loading = true

      registerObservable(
        selfUser.updateLocale(code)
          .pipe(
            o.catchError((err) => {
              logger.error(err)
              return Observable.empty()
            }),
            o.finalize(mobx.action(() => {
              vm.loading = false
            })),
          )
      )
    }),
  }: ViewModel))

  return vm
}

mkViewModel.contextTypes = {
  models: PT.shape({
    users: PT.object.isRequired,
  }).isRequired,
}

export default mkViewModel
